import React from 'react'
import {Box,Text,DataTable} from 'grommet';


function ShipmentQuoteBreakdown(props){
  if (props.billing){
    if (props.shipment.status === 'Fail'){
      return null
    } else {
      const columns = [{header: 'Charge Name',primary: true,footer:'Total Bill', property: 'name'},{property: 'price', header: "Charge Cost",render: (datum) => <Text>{datum.price.toFixed(2)}</Text>,footer: `${props.shipment.total_billing_price} ${props.shipment.total_billing_price_currency}`},{header:"Charge Currency",property:'currency'},{background: 'light-2',header: "Charge Markup/Rate",property: 'markup'}]
      return (
        <Box>
        <Box direction='row'><Text margin={{left: 'small'}} weight={'bold'} size="medium">Shipment Billing Breakdown</Text></Box>
        <DataTable margin={'small'} background={{header: { color: '#18445C' }}} border={{"body":"bottom"}} size='large' columns={columns} data={props.shipment.billing.ChargeBreakdown} onClickRow={() => {}} />
      </Box>
      )
    }   
  } else {
    if (props.shipment.status === 'Fail'){
      return null
    } else {
      const columns = [{header: 'Charge Name',primary: true,footer:'Quote Total', property: 'name'},{property: 'price', header: "Charge Cost",render: (datum) => <Text>{datum.price.toFixed(2)}</Text>,footer: `${props.shipment.quote.total_quote_price.toFixed(2)} ${props.shipment.quote.total_quote_price_currency}`},{header:"Charge Currency",property:'currency'},{background: 'light-2',header: "Charge Markup/Rate",property: 'markup'}]
      return (
        <Box>
        <Box direction='row'><Text margin={{left: 'small'}} weight={'bold'} size="medium">Shipment Quote Breakdown</Text></Box>
        <DataTable margin={'small'} background={{header: { color: '#18445C' }}} border={{"body":"bottom"}} size='large' columns={columns} data={props.shipment.quote.quote_breakdown} onClickRow={() => {}} />
      </Box>
      )
    }   
  }
 
  }


  export default ShipmentQuoteBreakdown